import { render, staticRenderFns } from "./radiobutton.vue?vue&type=template&id=312f4ff8&"
import script from "./radiobutton.vue?vue&type=script&lang=js&"
export * from "./radiobutton.vue?vue&type=script&lang=js&"
import style0 from "./radiobutton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports